import React from "react";

// react-bootstrap components
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Modal,
  Row,
} from "react-bootstrap";
import Select from "react-select";
// core components
import ReactTable from "components/ReactTable/ReactTable.js";
import { Query, useMutation } from "react-apollo";
import { GET_CLIENT } from "./queries";

import map from "lodash/map";
import find from "lodash/find";
import head from "lodash/head";
import compact from "lodash/compact";
import isEmpty from "lodash/isEmpty";
import includes from "lodash/includes";
import withSession from "./withSession";
import {
  ADD_RESOURCE_FOLDER_TO_CLIENT,
  UPDATE_RESOURCE_FOLDER,
  DELETE_RESOURCE_FOLDER,
  ADD_RESOURCE_TO_CLIENT,
  UPDATE_RESOURCE,
  DELETE_RESOURCE,
  IMAGE_UPLOAD,
} from "./mutations";
import Dropzone from "react-dropzone";
import ReactQuill from "react-quill";
import { modules } from "constants/reactQuill";

const MAXSIZE = 9 * 1024 * 1024; //bytes
const FILETYPES = ["application/pdf", "image/*", "audio/*", "video/*"];

function ResourceManager(props) {
  const [modal, setModal] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [modal2, setModal2] = React.useState(false);
  const [modal3, setModal3] = React.useState(false);
  const [deleteModal2, setDeleteModal2] = React.useState(false);
  const [modalPassword, setModalPassword] = React.useState(false);

  const [name, setName] = React.useState("");
  const [type, setType] = React.useState({
    value: "folder",
    label: "Folder",
  });
  const [folder, setFolder] = React.useState();
  const [showError, setShowError] = React.useState("");
  const [showErrorConfirm, setShowErrorConfirm] = React.useState("");

  const [editResourceFolderId, setEditResourceFolderId] = React.useState("");
  const [deleteResourceFolderId, setDeleteResourceFolderId] =
    React.useState("");
  const [editResourceId, setEditResourceId] = React.useState("");
  const [deleteResourceId, setDeleteResourceId] = React.useState("");
  // const [multipleActivities, setMultipleActivities] = React.useState("");

  const [fileLink, setFileLink] = React.useState(null);
  const [fileType, setFileType] = React.useState("");

  const [fileError, setFileError] = React.useState("");

  const validateFile = (file) => {
    if (file.size > MAXSIZE) {
      // this.setState({ error: 'file is too big' })
      setFileError("file is too big");
      return false;
    }

    // if (!includes(FILETYPES, file.type)) {
    //   this.setState({
    //     error: 'File Type not accepted',
    //     progress: null,
    //   })
    //   return false
    // }
    return true;
  };
  const getBase64ImageFromFile = async (file) => {
    if (!file) return null;
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.addEventListener(
        "load",
        function () {
          resolve(reader.result);
        },
        false
      );

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(file);
    });
  };
  const handleOnDrop = async (files, rejectedFiles) => {
    // this.setState({ error: null, progress: files.length })
    setFileError("");
    console.log(head(rejectedFiles)?.errors[0]?.message);
    if (!isEmpty(rejectedFiles)) {
      setFileError(head(rejectedFiles)?.errors[0]?.message);
      return;
    }
    let urls = await Promise.all(
      compact(
        map(files, async (file) => {
          console.log(file);
          if (validateFile(file)) {
            const url = await getBase64ImageFromFile(file);
            return url;
          }
          return null;
        })
      )
    );
    // setFileLink(head(urls))
    if (head(urls)) {
      uploadImage({
        variables: {
          fileUrl: head(urls),
          collection: `${props.session.me.clientName}/resources`,
        },
      }).then((data) => {
        setFileLink(data?.data?.uploadImage);
        setFileType(head(files)?.type);
      });
    }
  };

  const [addResourceFolderToClient] = useMutation(
    ADD_RESOURCE_FOLDER_TO_CLIENT
  );
  const [updateResourceFolder] = useMutation(UPDATE_RESOURCE_FOLDER);
  const [deleteResourceFolder] = useMutation(DELETE_RESOURCE_FOLDER);
  const [addResourceToClient] = useMutation(ADD_RESOURCE_TO_CLIENT);
  const [updateResource] = useMutation(UPDATE_RESOURCE);
  const [deleteResource] = useMutation(DELETE_RESOURCE);
  const [uploadImage] = useMutation(IMAGE_UPLOAD);

  const handleClose = () => {
    setModal(false);
    setName("");
    setType({
      value: "folder",
      label: "Folder",
    });
    setEditResourceFolderId("");
  };

  const handleClose2 = () => {
    setModal2(false);
    setName("");
    setFolder(null);
    setFileLink("");
    setFileType("");
    // setType({
    //   value: "folder",
    //   label: "Folder",
    // });
    setEditResourceId("");
  };

  const handleClose3 = () => {
    setModal3(false);
    setName("");
    setFolder(null);
    setFileLink("");
    setFileType("");
    // setType({
    //   value: "folder",
    //   label: "Folder",
    // });
    setEditResourceId("");
  };

  const handleOpenDelete = (resourcefolder) => {
    setDeleteModal(true);
    setDeleteResourceFolderId(resourcefolder._id);
  };

  const handleCloseDelete = (user) => {
    setDeleteModal(false);
    setDeleteResourceFolderId("");
  };

  const handleOpenDelete2 = (resource) => {
    setDeleteModal2(true);
    setDeleteResourceFolderId(editResourceFolderId);
    setDeleteResourceId(resource._id);
  };

  const handleCloseDelete2 = (user) => {
    setDeleteModal2(false);
    setDeleteResourceFolderId("");
    setDeleteResourceId("");
  };

  const handleAddResourceFolder = () => {
    let resourceFolder = {
      name,
      type: type?.value,
      // activities
    };

    addResourceFolderToClient({
      variables: {
        name: props.session.me.clientName,
        resourceFolder,
      },
      refetchQueries: [
        {
          query: GET_CLIENT,
          variables: {
            name: props.session.me.clientName,
          },
        },
      ],
    })
      .then(() => {
        handleClose();
      })
      .catch((error) => {
        setShowError(error.message);
      });
  };

  const handleOpenEdit = (resourcefolder) => {
    setModal(true);
    setName(resourcefolder.name);
    setType(
      find(options, (option) => {
        return option.value === resourcefolder.type;
      })
    );
    setEditResourceFolderId(resourcefolder._id);
    setShowError("");
  };

  const handleEditResourceFolder = async (editResourceFolderId) => {
    const resourceFolderUpdate = {
      name,
      type: type?.value,
    };
    try {
      await updateResourceFolder({
        variables: {
          folderId: editResourceFolderId,
          name: props.session.me.clientName,
          resourceFolderUpdate,
        },
      })
        .then(() => {
          handleClose();
        })
        .catch((error) => {
          setShowError(error.message);
        });
    } catch (error) {
      // Handle update error, e.g., showing an error message
      console.error("Error updating resourcefolder:", error);
    }
  };

  const handleDeleteResourceFolder = async (deleteResourceFolderId) => {
    try {
      await deleteResourceFolder({
        variables: {
          folderId: deleteResourceFolderId,
          name: props.session.me.clientName,
        },
      })
        .then(() => {
          handleCloseDelete();
        })
        .catch((error) => {
          setShowError(error.message);
        });
      // Handle successful update, e.g., showing a success message or redirecting
    } catch (error) {
      // Handle update error, e.g., showing an error message
      console.error("Error updating resourcefolder:", error);
    }
  };

  const handleAddResource = () => {
    let resource = {
      name,
      link: fileLink,
      type: fileType,
      // activities
    };

    addResourceToClient({
      variables: {
        name: props.session.me.clientName,
        folderId: folder.value,
        resource,
      },
      refetchQueries: [
        {
          query: GET_CLIENT,
          variables: {
            name: props.session.me.clientName,
          },
        },
      ],
    })
      .then(() => {
        handleClose2();
        handleClose3();
      })
      .catch((error) => {
        setShowError(error.message);
      });
  };

  const handleOpenEdit2 = (resource) => {
    setModal2(true);
    setName(resource.name);
    setFileLink(resource.link);
    setFileType(resource.type);
    setEditResourceId(resource._id);
    setFolder(editResourceFolderId);
    setShowError("");
  };

  const handleOpenEdit3 = (resource) => {
    setModal3(true);
    setName(resource.name);
    setFileLink(resource.link);
    setFileType(resource.type);
    setEditResourceId(resource._id);
    setFolder(editResourceFolderId);
    setShowError("");
  };

  const handleEditResource = async (editResourceId) => {
    const resourceUpdate = {
      name,
      link: fileLink,
      type: fileType,
    };
    try {
      await updateResource({
        variables: {
          resourceId: editResourceId,
          name: props.session.me.clientName,
          resourceUpdate,
        },
      })
        .then(() => {
          handleClose2();
          handleClose3();
        })
        .catch((error) => {
          setShowError(error.message);
        });
    } catch (error) {
      // Handle update error, e.g., showing an error message
      console.error("Error updating resourcefolder:", error);
    }
  };

  const handleDeleteResource = async (
    deleteResourceFolderId,
    deleteResourceId
  ) => {
    try {
      await deleteResource({
        variables: {
          folderId: deleteResourceFolderId,
          resourceId: deleteResourceId,
          name: props.session.me.clientName,
        },
      })
        .then(() => {
          handleCloseDelete2();
        })
        .catch((error) => {
          setShowError(error.message);
        });
      // Handle successful update, e.g., showing a success message or redirecting
    } catch (error) {
      // Handle update error, e.g., showing an error message
      console.error("Error updating resourcefolder:", error);
    }
  };

  const options = [
    { value: "folder", label: "Folder" },
    // { value: "lesson", label: "Lesson" },
    // { value: "workout", label: "Workout" },
  ];

  return (
    <Query
      query={GET_CLIENT}
      variables={{
        name: props.session.me.clientName,
      }}
    >
      {({ loading, data, refetch }) => {
        if (loading) return "Loading...";
        const { getClient } = data;
        const { resourceFolders } = getClient || {};

        const tableData = map(resourceFolders, (resourcefolder, key) => {
          return {
            id: key,
            ...resourcefolder,
          };
        });

        const resouceTableData = map(
          find(resourceFolders, (folder) => {
            return folder._id === editResourceFolderId;
          })?.resources,
          (resouce, key) => {
            return {
              id: key,
              ...resouce,
            };
          }
        );
        return (
          <>
            <Container fluid>
              <Row>
                <Col md="12">
                  <h4 className="title">Resource Manager</h4>
                  {/* <p className="category">
                          A powerful react plugin handcrafted by our friends from{" "}
                          <a
                            href="https://react-table.tanstack.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            react-table
                          </a>
                          . It is a highly flexible tool, based upon the foundations of
                          progressive enhancement on which you can add advanced interaction
                          controls. Please check out their{" "}
                          <a
                            href="https://react-table.tanstack.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            full documentation.
                          </a>
                        </p> */}
                  <Card>
                    <Card.Body>
                      <ReactTable
                        data={tableData}
                        columns={[
                          {
                            header: "Folder Name",
                            accessorKey: "name",
                          },
                          {
                            header: "Type",
                            accessorKey: "type",
                          },
                          {
                            header: "Resource Count",
                            accessorKey: "resources.length",
                          },
                          {
                            header: "Actions",
                            accessorKey: "actions",
                            enableSorting: false,
                            enableColumnFilter: false,
                            cell: ({ row }) => {
                              const resourceFolder = row.original;
                              return (
                                // we've added some custom button actions
                                <div className="actions-right">
                                  {/* use this button to add a edit kind of action */}
                                  <Button
                                    variant="warning"
                                    size="sm"
                                    className="text-warning btn-link edit"
                                    onClick={() =>
                                      handleOpenEdit(resourceFolder)
                                    }
                                  >
                                    <i className="fa fa-edit" />
                                  </Button>{" "}
                                  <Button
                                    variant="danger"
                                    size="sm"
                                    className="text-danger btn-link edit"
                                    onClick={() =>
                                      handleOpenDelete(resourceFolder)
                                    }
                                  >
                                    <i className="fa fa-trash" />
                                  </Button>{" "}
                                </div>
                              );
                            },
                          },
                        ]}
                        /*
                                You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                              */
                        className="-striped -highlight primary-pagination"
                      />
                    </Card.Body>
                  </Card>
                </Col>
                <Col xs="12" style={{ marginTop: 25, textAlign: "right" }}>
                  <Button
                    onClick={() => setModal(!modal)}
                    style={{
                      paddingLeft: 20,
                      paddingRight: 20,
                      paddingTop: 15,
                      paddingBottom: 15,
                      fontSize: 16,
                      fontWeight: "bold",
                    }}
                  >
                    Add Folder
                  </Button>
                </Col>
                <Col xs="12" style={{ marginTop: 25, textAlign: "right" }}>
                  <Button
                    onClick={() => setModal2(!modal2)}
                    style={{
                      paddingLeft: 20,
                      paddingRight: 20,
                      paddingTop: 15,
                      paddingBottom: 15,
                      fontSize: 16,
                      fontWeight: "bold",
                    }}
                  >
                    Add Resource
                  </Button>
                </Col>
                <Col xs="12" style={{ marginTop: 25, textAlign: "right" }}>
                  <Button
                    onClick={() => setModal3(!modal3)}
                    style={{
                      paddingLeft: 20,
                      paddingRight: 20,
                      paddingTop: 15,
                      paddingBottom: 15,
                      fontSize: 16,
                      fontWeight: "bold",
                    }}
                  >
                    Add Resource Link
                  </Button>
                </Col>
              </Row>
            </Container>
            <Modal
              className="modal-primary"
              onHide={handleClose}
              show={modal}
              size="md"
            >
              <Modal.Header className="justify-content-center">
                <label>{editResourceFolderId ? "Edit" : "Add"} Folder</label>
              </Modal.Header>
              <Modal.Body>
                <Form action="#" method="#">
                  <Form.Group>
                    <label>Name</label>
                    <Form.Control
                      value={name}
                      placeholder="Name"
                      type="string"
                      onChange={(event) => setName(event.target.value)}
                    />
                  </Form.Group>
                  <Form.Group>
                    <label>Type</label>
                    <Select
                      className="react-select info"
                      classNamePrefix="react-select"
                      placeholder="Choose Ages"
                      name="multipleAgeSelect"
                      closeMenuOnSelect={true}
                      value={type}
                      onChange={(value) => {
                        setType(value);
                      }}
                      options={options} // Use the options array here
                    />
                  </Form.Group>
                </Form>
                <ReactTable
                  data={resouceTableData}
                  columns={[
                    {
                      header: "Folder Name",
                      accessorKey: "name",
                    },
                    {
                      header: "Type",
                      accessorKey: "type",
                    },
                    {
                      header: "File Link",
                      accessorKey: "link",
                    },
                    {
                      header: "Actions",
                      accessorKey: "actions",
                      enableSorting: false,
                      enableColumnFilter: false,
                      cell: ({ row }) => {
                        const resouce = row.original;
                        return (
                          // we've added some custom button actions
                          <div className="actions-right">
                            {/* use this button to add a edit kind of action */}
                            <Button
                              variant="warning"
                              size="sm"
                              className="text-warning btn-link edit"
                              onClick={
                                includes(resouce?.type, "link")
                                  ? () => handleOpenEdit3(resouce)
                                  : () => handleOpenEdit2(resouce)
                              }
                            >
                              <i className="fa fa-edit" />
                            </Button>{" "}
                            <Button
                              variant="danger"
                              size="sm"
                              className="text-danger btn-link edit"
                              onClick={() => handleOpenDelete2(resouce)}
                            >
                              <i className="fa fa-trash" />
                            </Button>{" "}
                          </div>
                        );
                      },
                    },
                  ]}
                  /*
                          You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                        */
                  className="-striped -highlight primary-pagination"
                />
              </Modal.Body>
              <div className="modal-footer">
                <Button
                  className="btn-simple"
                  onClick={handleClose}
                  variant="link"
                >
                  Cancel
                </Button>
                <Button
                  className="btn-simple"
                  onClick={
                    editResourceFolderId
                      ? () => handleEditResourceFolder(editResourceFolderId)
                      : handleAddResourceFolder
                  }
                  variant="outlined"
                  color="primary"
                  disabled={!name || !type} // || !activities}
                >
                  Save
                </Button>
              </div>
            </Modal>

            <Modal
              className="modal-primary"
              onHide={handleCloseDelete}
              show={deleteModal}
              size="md"
            >
              <Modal.Header className="justify-content-center">
                <label>Delete Folder</label>
              </Modal.Header>
              <Modal.Body>
                Are you sure you want to delete this Folder? This action cannot
                be undone
              </Modal.Body>
              <div className="modal-footer">
                <Button
                  className="btn-simple"
                  onClick={handleCloseDelete}
                  variant="outlined"
                >
                  Cancel
                </Button>
                <Button
                  className="btn-simple"
                  onClick={() =>
                    handleDeleteResourceFolder(deleteResourceFolderId)
                  }
                  variant="danger"
                  color="primary"
                >
                  Delete Folder
                </Button>
              </div>
            </Modal>

            <Modal
              className="modal-primary"
              onHide={handleClose2}
              show={modal2}
              size="md"
            >
              <Modal.Header className="justify-content-center">
                <label>{editResourceId ? "Edit" : "Add"} Resource</label>
              </Modal.Header>
              <Modal.Body>
                <Form action="#" method="#">
                  <Form.Group>
                    <label>Name</label>
                    <Form.Control
                      value={name}
                      placeholder="Name"
                      type="string"
                      onChange={(event) => setName(event.target.value)}
                    />
                  </Form.Group>
                  {!editResourceFolderId && (
                    <Form.Group>
                      <label>Folder</label>
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        placeholder="Choose Folder"
                        name="multipleAgeSelect"
                        closeMenuOnSelect={true}
                        value={folder}
                        onChange={(value) => {
                          setFolder(value);
                        }}
                        options={map(resourceFolders, (folder) => {
                          return {
                            value: folder._id,
                            label: folder.name,
                          };
                        })} // Use the options array here
                      />
                    </Form.Group>
                  )}
                  <Form.Group>
                    <label>Resource File</label>
                    <Dropzone
                      onDrop={handleOnDrop}
                      accept={FILETYPES.join(",")}
                      maxSize={MAXSIZE}
                      multiple={false}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <section style={{ padding: 0 }}>
                          <div {...getRootProps()}>
                            <input {...getInputProps()} />
                            <Button
                              size="small"
                              variant="contained"
                              color="primary"
                            >
                              {"Upload File"}
                            </Button>
                          </div>
                        </section>
                      )}
                    </Dropzone>
                    {fileError && <label>{fileError}</label>}
                    <Form.Control
                      value={fileLink}
                      placeholder="File Link"
                      type="string"
                      disabled
                      onChange={(event) => setFileLink(event.target.value)}
                      style={{ marginTop: 5, marginBottom: 5 }}
                    />
                    {/* {fileLink && (
                      <img src={fileLink} height="100" width="150" />
                    )} */}
                  </Form.Group>
                  <Form.Group>
                    <Form.Control
                      value={fileType}
                      placeholder="File Type"
                      type="string"
                      disabled
                      onChange={(event) => setFileType(event.target.value)}
                      style={{ marginTop: 5, marginBottom: 5 }}
                    />
                    {/* {fileLink && (
                      <img src={fileLink} height="100" width="150" />
                    )} */}
                  </Form.Group>
                </Form>
              </Modal.Body>
              <div className="modal-footer">
                <Button
                  className="btn-simple"
                  onClick={handleClose2}
                  variant="link"
                >
                  Cancel
                </Button>
                <Button
                  className="btn-simple"
                  onClick={
                    editResourceId
                      ? () => handleEditResource(editResourceId)
                      : handleAddResource
                  }
                  variant="outlined"
                  color="primary"
                  disabled={!name || !folder || !fileLink} // || !activities}
                >
                  Save
                </Button>
              </div>
            </Modal>

            <Modal
              className="modal-primary"
              onHide={handleClose3}
              show={modal3}
              size="md"
            >
              <Modal.Header className="justify-content-center">
                <label>{editResourceId ? "Edit" : "Add"} Resource Link</label>
              </Modal.Header>
              <Modal.Body>
                <Form action="#" method="#">
                  <Form.Group>
                    <label>Name</label>
                    <Form.Control
                      value={name}
                      placeholder="Name"
                      type="string"
                      onChange={(event) => setName(event.target.value)}
                    />
                  </Form.Group>
                  {!editResourceFolderId && (
                    <Form.Group>
                      <label>Folder</label>
                      <Select
                        className="react-select info"
                        classNamePrefix="react-select"
                        placeholder="Choose Folder"
                        name="multipleAgeSelect"
                        closeMenuOnSelect={true}
                        value={folder}
                        onChange={(value) => {
                          setFolder(value);
                        }}
                        options={map(resourceFolders, (folder) => {
                          return {
                            value: folder._id,
                            label: folder.name,
                          };
                        })} // Use the options array here
                      />
                    </Form.Group>
                  )}
                  <Form.Group>
                    <label>Resource File</label>
                    <Form.Control
                      value={fileLink}
                      placeholder="File Link"
                      type="string"
                      onChange={(event) => setFileLink(event.target.value)}
                      style={{ marginTop: 5, marginBottom: 5 }}
                    />
                    {/* {fileLink && (
                      <img src={fileLink} height="100" width="150" />
                    )} */}
                  </Form.Group>
                  <Form.Group>
                    <Form.Control
                      as="select"
                      value={fileType}
                      onChange={(event) => setFileType(event.target.value)}
                      style={{ marginTop: 5, marginBottom: 5 }}
                    >
                      <option>Select link type</option>
                      <option value="video link">Video</option>
                      <option value="web link">Webpage</option>
                    </Form.Control>
                  </Form.Group>
                </Form>
              </Modal.Body>
              <div className="modal-footer">
                <Button
                  className="btn-simple"
                  onClick={handleClose3}
                  variant="link"
                >
                  Cancel
                </Button>
                <Button
                  className="btn-simple"
                  onClick={
                    editResourceId
                      ? () => handleEditResource(editResourceId)
                      : handleAddResource
                  }
                  variant="outlined"
                  color="primary"
                  disabled={!name || !folder || !fileLink} // || !activities}
                >
                  Save
                </Button>
              </div>
            </Modal>

            <Modal
              className="modal-primary"
              onHide={handleCloseDelete2}
              show={deleteModal2}
              size="md"
            >
              <Modal.Header className="justify-content-center">
                <label>Delete Resource</label>
              </Modal.Header>
              <Modal.Body>
                Are you sure you want to delete this resource? This action
                cannot be undone
              </Modal.Body>
              <div className="modal-footer">
                <Button
                  className="btn-simple"
                  onClick={handleCloseDelete2}
                  variant="outlined"
                >
                  Cancel
                </Button>
                <Button
                  className="btn-simple"
                  onClick={() =>
                    handleDeleteResource(
                      deleteResourceFolderId,
                      deleteResourceId
                    )
                  }
                  variant="danger"
                  color="primary"
                >
                  Delete Resource
                </Button>
              </div>
            </Modal>
          </>
        );
      }}
    </Query>
  );
}

export default withSession(ResourceManager);
